import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import StateSave from "./StateSave";


const StateEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    let response33 = useInvoke("WebApps", "33", null);
    let response50 = useInvoke("WebApps", "50", {"@StateId": id});
    
    const [state, setState] = useState({});

    useEffect(() => {

        //Get countries
        if (response33.data.payload != undefined && response33.isPending == false) {
            let data = JSON.parse(response33.data.payload).data;

            if(document.getElementById("countryID") != null) {
                let select = document.getElementById("countryID");

                let defaultOption = document.createElement('option');
                defaultOption.text = "Select Country";
                defaultOption.value = "";
                select.options.add(defaultOption);

                data.forEach(country => {
                    let option = document.createElement('option');
                    option.text = country[1];
                    option.value = country[0];
                    select.options.add(option);
                });
            }
            
        }

        //Get state by ID
        if (response50.data.payload != undefined && response50.isPending == false) {
            let data = JSON.parse(response50.data.payload).data[0];

            setState(
                {
                    StateID: data[0],
                    StateName: data[1],
                    StateAbbr: data[2],
                    CountryName: data[3],
                    CreatedDate: data[4],
                    CountryId: data[5]
                }
            );
        }

    }, [response33.isPending, response50.isPending]);

    useEffect(() => {

        if (document.getElementById("countryID") != null) {
            document.getElementById("countryID").value = state["CountryId"]
        }

    }, [state])

    const handleFormSubmit = (e) => {

        let stateid = id;

        let valid = true;

        let statename = "";
        (document.getElementById("state").value == '') ? 
        statename = statename = document.getElementById("state").placeholder : 
        statename = document.getElementById("state").value;

        let stateabbr = "";
        (document.getElementById("abbr").value == '') ? 
        stateabbr = stateabbr = document.getElementById("abbr").placeholder : 
        stateabbr = document.getElementById("abbr").value;

        let modifiedbyid = user["id"];
        let deleted = "0";

        let countryid = "";
        if (document.getElementById("countryID").value != "") {
            countryid = document.getElementById("countryID").value;
        }
        else {
            valid = false;
            toast.error("Country required");
        }

        if(valid) {
            StateSave(stateid, statename, stateabbr, modifiedbyid, deleted, countryid);
            toast.success('Success');
            navigate("/State");
        }
    };
   
    document.title = "State - Edit";
    return ( 
        <div className="stateEdit">
            {user["email"] != undefined && 
                <>
                    {(response33.isPending == false && response50.isPending == false) &&

                        <div className="container body-content" style={{marginTop: "25px"}}>
                                
                            <h2>Edit State</h2>

                            <form id="stateForm" noValidate="novalidate" autoComplete="off">  

                                <div className="form-group">
                                    <label htmlFor="countryID">Country</label>
                                    <select className="form-control" id="countryID" name="countryID"></select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="state">State / Province</label>
                                    <input className="form-control" id="state" name="state" type="text" defaultValue={state["StateName"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="abbr">Abbr&nbsp;<div style={{color: "lightgray"}}>(8 char. MAX)</div></label>
                                    <input className="form-control" id="abbr" name="abbr" type="text" defaultValue={state["StateAbbr"]} autoComplete="off"/>
                                </div>
                            </form>
                            <Link to="/State" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>
                            <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                          
                        </div>
                    }
                </>
            }
        </div>
     );
}
 
export default StateEdit;